import { OfficialDealerBanner } from "@/components/sections/OfficialDealerBanner";
import { CreditSeals } from "@/components/CreditSeals";
import { LiveTrustTicker } from "@/components/sections/LiveTrustTicker";

/**
 * Trust-stacken som visas direkt under hero-bilden på varje undersida:
 *   1. OfficialDealerBanner — 3M-auktoriseringen
 *   2. CreditSeals — UC + AAA + "Verifierad & kreditvärdig"
 *   3. LiveTrustTicker — "3 500+ nöjda kunder · sedan 2008 · 10 års garanti"
 *
 * Använd den i page-wrappers (ContentPage, CityPage, GuideHero) och direkt
 * efter <Hero/> / <PageHero/> / <OffertHero/> på sidor som inte använder
 * någon wrapper.
 */
export function HeroTrustStack({ showTicker = true }: { showTicker?: boolean } = {}) {
  return (
    <>
      <OfficialDealerBanner />
      <CreditSeals variant="light" showLabel showStats />
      {showTicker && <LiveTrustTicker />}
    </>
  );
}
